import React from 'react';
import './ActionCard.css';

const ActionCard = ({
  title,
  description,
  icon,
  badge,
  stats,
  buttonText,
  buttonAction,
  variant = 'secondary',
  urgent = false
}) => {
  return (
    <div className={`action-card ${variant} ${urgent ? 'urgent' : ''}`}>
      <div className="action-card-header">
        <div className="action-card-icon-wrapper">
          {icon}
        </div>
        {badge && (
          <div className={`action-card-badge ${urgent ? 'badge-urgent' : ''}`}>
            {badge}
          </div>
        )}
      </div>

      <div className="action-card-body">
        <h3>{title}</h3>
        <p>{description}</p>

        {stats && stats.length > 0 && (
          <div className="action-card-stats">
            {stats.map((stat, index) => (
              <div key={index} className="stat-item">
                <span className="stat-label">{stat.label}</span>
                <span className="stat-value">{stat.value}</span>
              </div>
            ))}
          </div>
        )}
      </div>

      <div className="action-card-footer">
        <button className="action-btn" onClick={buttonAction}>
          {buttonText}
          <svg
            className="arrow-icon"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M7.5 15L12.5 10L7.5 5"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default ActionCard;
